






import Vue from 'vue';
import Component from 'vue-class-component';
import { mapGetters, mapState } from 'vuex';
import { GETTERS_KEYS, SUBMODULES_PATHS } from '../../store';

@Component({
  computed: {
    ...mapState(SUBMODULES_PATHS.core, ['open']),
    ...mapGetters({
      components: GETTERS_KEYS.config.components,
      renderEmptySearch: GETTERS_KEYS.search.showEmptySearch
    })
  }
})
export default class EmptySearch extends Vue {
  open: boolean;
  renderEmptySearch: boolean;
}
